import React from 'react';

const CardIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60435 1H17.4348C18.2957 1 19 1.7875 19 2.79375V13.25C19 14.2125 18.2957 15 17.4348 15H2.60435C1.70435 15 1 14.2125 1 13.25V2.79375C1 1.7875 1.70435 1 2.60435 1Z"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path d="M1 4.80448H19" stroke="#555B67" strokeWidth="2" />
    <path d="M3.85645 8.72293H7.76949" stroke="#555B67" strokeWidth="2" />
  </svg>
);

export default CardIcon;
